import { memo } from 'react';
import { View, Text } from 'react-native';
import { NoCasesView, Container } from '../components';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentCase } from '../cases/selector';

import Success from '../success/success';
import Events from '../success/events';

export default memo(function MilPatientHome(props) {
  const currentCaseObj = useSelector((state) => getCurrentCase(state));
  return (
    <Container scrollView={true}>
      {!currentCaseObj ? (
        <NoCasesView />
      ) : (
        <>
          <Success screenVisible={props.screenVisible} />
          <Events screenVisible={props.screenVisible} currentCaseObj={currentCaseObj} />
        </>
      )}
    </Container>
  );
});
